import ReactOnRails from 'react-on-rails/client';
import StaticPagesLogo from '../../app/StaticPagesLogo.jsx';

ReactOnRails.register({StaticPagesLogo});